// Dependencias generales
import React from "react";
import { useEffect } from 'react';
import '../../../css/common.css';
import '../../../css/initialConfigStyle.css';
import ReactGA from "react-ga4";

var generalCommonJS = require("../../../js/generalCommon.js")
var initialConfigCommonJS = require("../../../js/initialConfigCommon.js")

// Advisory - Energy Billing
const ConsumptionControl = () => {
  
  useEffect(() => {    

    document.title = "HELIAS - Asesoramiento: Dispositivos inteligentes"     
    document.querySelector('meta[name="description"]').setAttribute("content", "Usar dispositivos inteligentes te servirá para ahorrar automatizando tareas, ayudando a controlar gastos innecesarios por descuidos.");

    console.log("Abro asesoramiento para dispositivos inteligentes.")    

  });

  return (      
    <main className="no-background">

      <section className="step">
        <div className="content-wrapper">          

              <p>Una manera muy potente de ahorrar es teniendo controlado el consumo de los aparatos de tu instalación para encenderlos o apagarlos en función de la energía disponible o de la tarifa horaria. Además puedes crear <strong>reglas de comportamiento</strong> para que yo me ocupe de hacer que todo funcione como quieras mientras no estás pendiente de ellos. Estos serían los esenciales:</p>

              <div className="accordion-wrapper">

                <details className="accordion green">
                  <summary className="title">
                    <figure className="avatar size-l"><span className="material-icon">electric_meter</span></figure>            
                    <h1 className="size-l">Enchufe inteligente</h1>
                  </summary>                

                  <div className="accordion-content vertical gap-04">
                    <a href="https://es.aliexpress.com/item/1005005404337425.html?spm=a2g0o.productlist.seoads.10.7a654c79u5dcnt&p4p_pvid=20230806031940685578199573480007198445_5&s=p" className="selector icon-wrapper no-icon xxl" target="_blank" rel="noopener noreferrer" onClick={() => generalCommonJS.registrarEventoAnalitica(ReactGA, 'CROSS-SELLING', 'XSELL - Morebetter MEDIDOR', "", "")}>                    
                      <figure className="avatar size-xxl"><img src="https://ae01.alicdn.com/kf/S4cfc634b1e2c4593a9a286d51523d4ff8/Enchufe-inteligente-Tuya-16A-20A-enchufe-WiFi-funci-n-de-sincronizaci-n-de-monitoreo-de-energ.jpg_640x640.jpg" alt=""/></figure>
                      <div className="content vertical gap-02">
                        <h1 className="headline-03">Smart And Simple Life 16A EU Socket</h1>                        
                      </div>
                    </a>

                    <p>Con este dispositivo puedes encender y apagar aparatos enchufables de forma remota, los hay con y sin medidor de consumo, aunque recomendamos comprarlos siempre con monitor ya que apenas hay diferencia de precio. Si hay algún aparato que te interese monitorizar en tiempo real contínuamente puedes dejar este enchufe fijo y yo me ocuparé de controlarlo.</p>                    
                    
                  </div>

                </details>
             
                <details className="accordion green">
                  <summary className="title">
                    <figure className="avatar size-l"><span className="material-icon">toggle_on</span></figure>            
                    <h1 className="size-l">Relé inteligente WIFI</h1>
                  </summary>                
                  
                  <div className="accordion-content vertical gap-04">
                    <a href="https://es.aliexpress.com/item/4000478973917.html?gps-id=pcStoreLeaderboard&scm=1007.22922.271278.0&scm_id=1007.22922.271278.0&scm-url=1007.22922.271278.0&pvid=f60e3c32-a133-44c0-a870-c2bfdc1dc676&_t=gps-id%3ApcStoreLeaderboard%2Cscm-url%3A1007.22922.271278.0%2Cpvid%3Af60e3c32-a133-44c0-a870-c2bfdc1dc676%2Ctpp_buckets%3A668%232846%238114%231999&pdp_ext_f=%7B%22sku_id%22%3A%2212000028355868166%22%2C%22sceneId%22%3A%2212922%22%7D&pdp_npi=2%40dis%21EUR%217.78%214.9%21%21%21%21%21%40211b5dec16650437593068412ebac8%2112000028355868166%21rec&spm=a2g0o.store_pc_home.smartLeaderboard_2002535824422.4000478973917&gatewayAdapt=glo2esp" className="selector icon-wrapper no-icon xxl" target="_blank" rel="noopener noreferrer" onClick={() => generalCommonJS.registrarEventoAnalitica(ReactGA, 'CROSS-SELLING', 'XSELL - EACHEN WiFi ST-DC1', "", "")}>                    
                      <figure className="avatar size-xxl"><img src="https://ae01.alicdn.com/kf/S4d3ce2ca20414c0dadf5b6bab5809443A/M-dulo-de-rel-Wifi-para-Control-remoto-por-aplicaci-n-eWeLink-rel-de-retardo-inal.jpg_Q90.jpg_.webp" alt=""/></figure>
                      <div className="content vertical gap-02">
                        <h1 className="headline-03">EACHEN WiFi ST-DC1 para aplicación EWELINK</h1>                                        
                      </div>
                    </a>

                    <p>Para aparatos que usen relés, como motores, para el encendido o apagado necesitarás un dispositivo como este.</p>                    
                    
                  </div>

                </details>

                <details className="accordion green">
                  <summary className="title">
                    <figure className="avatar size-l"><span className="material-icon">settings_remote</span></figure>            
                    <h1 className="size-l">Control remoto universal por infrarojos inteligente</h1>
                  </summary>                
                  
                  <div className="accordion-content vertical gap-04">
                    <a href="https://www.amazon.es/RM4-inal%C3%A1mbrico-transmisor-acondicionado-inteligente/dp/B09DS21XHS/ref=sr_1_8?__mk_es_ES=%C3%85M%C3%85%C5%BD%C3%95%C3%91&crid=1VP9GQ1TS7MLM&keywords=Broadlink+RM4+MINI&qid=1665044287&qu=eyJxc2MiOiIyLjgyIiwicXNhIjoiMi45NCIsInFzcCI6IjIuNjUifQ%3D%3D&s=electronics&sprefix=broadlink+rm4+mini%2Celectronics%2C191&sr=1-8" className="selector icon-wrapper no-icon xxl" target="_blank" rel="noopener noreferrer" onClick={() => generalCommonJS.registrarEventoAnalitica(ReactGA, 'CROSS-SELLING', 'XSELL - BROADLINK RM4', "", "")}>                    
                      <figure className="avatar size-xxl"><img src="https://ae01.alicdn.com/kf/H9ae1c72b19f0406387d47b49e49d10b6t/Broadlink-controlador-inteligente-RM4-Mini-Universal-m-dulo-de-automatizaci-n-del-hogar-WiFi-funciona-con.jpg_Q90.jpg_.webp" alt=""/></figure>
                      <div className="content vertical gap-02">
                        <h1 className="headline-03">Broadlink RM4 Mini Universal WiFi IR</h1>                                 
                      </div>
                    </a>

                    <p>Con este dispositivo puedes controlar desde tu móvil cualquier aparato que tenga un mando a distancia que funcione por infra-rojos (casi todos). Con un solo dispositivo de estos puedes controlar a la vez la tele, el equipo de música, el aire acondicionado, proyectores, luces led, etc...</p>                    
                                    
                  </div>

                </details>

              </div>
              
              <div className="vertical gap-02">
                <p>Esto sería lo "básico / imprescindible" para empezar a ahorrar y ser eficiente, pero además de estos existen millones de dispositivos inteligentes más:</p>
                <ul className="default-list">
                  <li className="success"><strong>Dispositivos simples:</strong> termostatos, sistema de riego, etc... </li>
                  <li className="success"><strong>Electrodomésticos:</strong> lavadoras, neveras, televisiones, etc... </li>
                  <li className="success">¡Hasta los <strong>coches</strong> los son ya!</li>
                </ul>  
                <p>Pero obviamente <strong>no es necesario que te compres todos ellos o que cambies los que ya tienes</strong>. Yo puedo ayudarte a combinar los que tengas y así tener funcionalidades avanzadas sin necesidad de comprar más. Por ejemplo, con el control remoto y el relé podrías tener un termostato.</p>
                <p>Como ves esto de los dispositivos inteligentes es un mundo, es por eso que te aconsejo que empieces con los básicos, según vayas necesitando algo te hagas con alguno más y sobre todo te animo a que juegues conmigo creando reglas para sacarle el máximo partido a tu instalación.</p>              
              </div>

          { initialConfigCommonJS.existeSesion() ?      
            <fieldset>            
              <button id="opcionAvanzado" className="button primary full-width" onClick={() => window.location="/InstallationConfiguration/Devices"}>¿Acabas de recibir tu dispositivo inteligente? Configurarlo aquí</button>         
            </fieldset>
          :
            <></>
          }

        </div>        

      </section>

    </main>
  )
}

export default ConsumptionControl